// Detección simple de dispositivo (PC o móvil)
document.addEventListener('DOMContentLoaded', () => {
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent) || window.innerWidth < 768;
  document.body.classList.add(isMobile ? 'data-browser-cel' : 'data-browser-pc');
  console.log('Dispositivo detectado:', isMobile ? 'Móvil' : 'PC');
});
